import { LinkActivationType } from '#pplx/frontend/composer-sdk/link.js';
import { createPluginFactory } from '#pplx/frontend/composer-sdk/plugins/createPluginFactory.js';
const createAskLinkPlugin = createPluginFactory({
    name: 'ask-link',
    capabilities: [
        {
            kind: 'link',
            configure: ({ onLinkClick }) => ({
                matchers: ['url', 'email'],
                markdownShortcut: true,
                suppressIn: ['codeFence'],
                activation: LinkActivationType.NEW_TAB,
                onLinkClick,
            }),
        },
    ],
});
export const askLinkPlugin = (props = {}) => createAskLinkPlugin(props);
//# sourceMappingURL=askLinkPlugin.js.map